import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionVideos from "../../containers/PageHome/SectionVideos";


const numeroDiTelefono = process.env.REACT_APP_WHATSAPP_NUMERO;
const emailContatto = process.env.REACT_APP_EMAILCONTATTO;
const indirizzo = process.env.REACT_APP_INDIRIZZO;
const googleMapsLink = process.env.REACT_APP_GOOGLEMAPSINDIRIZZO;

export interface PageContactProps {
  className?: string;
}

const info = [
  {
    title: "🗺 INDIRIZZO",
    desc: indirizzo,
    link: googleMapsLink,
  },
  {
    title: "💌 EMAIL",
    desc: emailContatto,
    link: `mailto:${emailContatto}`,
  },
  {
    title: "☎ TELEFONO",
    desc: numeroDiTelefono,
    link: `tel:${numeroDiTelefono}`,
  },
];

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  
  const [isFormValid, setIsFormValid] = useState(false);


    // const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    //   e.preventDefault();
    //   // Gestisci l'invio dei dati qui
    //   console.log("Modulo inviato");
    //   // console log dei dettagli inviati
    //   const formData = new FormData(e.currentTarget);
    //   const data = Object.fromEntries(formData.entries());
    //   console.log(data);
    // };

//     const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//       e.preventDefault();
    
//       // Ottieni i dati dal modulo
//       const formData = new FormData(e.currentTarget);
//       const data = Object.fromEntries(formData.entries());
    
//       // Prepara il messaggio da inviare
//       const whatsappMessage = `Salve, 
// la contatto dal sito web di *Villa Greco*.%0A%0A
// Ecco i miei dettagli:%0A
// - *Nome Completo*: ${encodeURIComponent(data.fullName as string)}%0A
// - *Email*: ${encodeURIComponent(data.email as string)}%0A
// - *Telefono*: ${encodeURIComponent(data.phoneNumber as string)}%0A%0A
// *Messaggio*:%0A${encodeURIComponent(data.message as string)}%0A%0A
// Attendo un suo gentile riscontro.%0A
// Grazie mille e buona giornata!`;

    
//       // Costruisci l'URL di WhatsApp
//       const whatsappUrl = `https://wa.me/${numeroDiTelefono}?text=${whatsappMessage}`;
    
//       // Reindirizza l'utente all'URL di WhatsApp
//       window.open(whatsappUrl, "_blank");
//     };

const handleWhatsAppSubmit = () => {
  const fullName = (document.getElementsByName("fullName")[0] as HTMLInputElement).value;
  const email = (document.getElementsByName("email")[0] as HTMLInputElement).value;
  const phoneNumber = (document.getElementsByName("phoneNumber")[0] as HTMLInputElement).value;
  const message = (document.getElementsByName("message")[0] as HTMLTextAreaElement).value;

  const whatsappMessage = `Salve, 
la contatto dal sito web di *Villa Greco*.%0A%0A
Ecco i miei dettagli:%0A
- *Nome Completo*: ${encodeURIComponent(fullName)}%0A
- *Email*: ${encodeURIComponent(email)}%0A
- *Telefono*: ${encodeURIComponent(phoneNumber)}%0A%0A
*Messaggio*:%0A${encodeURIComponent(message)}%0A%0A
Attendo un suo gentile riscontro.%0A
Grazie mille e buona giornata!`;

  const whatsappUrl = `https://wa.me/${numeroDiTelefono}?text=${whatsappMessage}`;
  window.open(whatsappUrl, "_blank");
};

const handleEmailSubmit = () => {
  const fullName = (document.getElementsByName("fullName")[0] as HTMLInputElement).value;
  const email = (document.getElementsByName("email")[0] as HTMLInputElement).value;
  const phoneNumber = (document.getElementsByName("phoneNumber")[0] as HTMLInputElement).value;
  const message = (document.getElementsByName("message")[0] as HTMLTextAreaElement).value;

  const emailSubject = `Richiesta di Contatto da Villa Greco`;
  const emailBody = `Salve,\n\nLa contatto dal sito web di Villa Greco.\n\nEcco i miei dettagli:\n\nNome Completo: ${fullName}\nEmail: ${email}\nTelefono: ${phoneNumber}\n\nMessaggio:\n${message}\n\nAttendo un suo gentile riscontro.\n\nGrazie mille e buona giornata!`;

  const emailUrl = `mailto:${emailContatto}?subject=${encodeURIComponent(
    emailSubject
  )}&body=${encodeURIComponent(emailBody)}`;
  window.location.href = emailUrl;
};


const handleInputChange = () => {
  const fullName = (document.getElementsByName("fullName")[0] as HTMLInputElement).value;
  const email = (document.getElementsByName("email")[0] as HTMLInputElement).value;
  const phoneNumber = (document.getElementsByName("phoneNumber")[0] as HTMLInputElement).value;
  const message = (document.getElementsByName("message")[0] as HTMLTextAreaElement).value;

  const isValid =
    fullName.trim() !== "" &&
    email.trim() !== "" &&
    phoneNumber.trim() !== "" &&
    message.trim() !== "";
  setIsFormValid(isValid);
};


const handleReset = () => {
  (document.getElementsByName("fullName")[0] as HTMLInputElement).value = "";
  (document.getElementsByName("email")[0] as HTMLInputElement).value = "";
  (document.getElementsByName("phoneNumber")[0] as HTMLInputElement).value = "";
  (document.getElementsByName("message")[0] as HTMLTextAreaElement).value = "";
  setIsFormValid(false);
};


  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Helmet>
        <title>Contattaci || Villa Greco</title>
      </Helmet>
      <div className="mb-24 lg:mb-32">
        <h2 className="my-16 sm:my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Contattaci
        </h2>
        <div className="container max-w-7xl mx-auto">
          <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-12 ">
            <div className="max-w-sm space-y-8">
              {info.map((item, index) => (
                <div key={index}>
                  <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                    {item.title}
                  </h3>
                  <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    {item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        {item.desc}
                      </a>
                    ) : (
                      item.desc
                    )}
                  </span>
                </div>
              ))}
              <div>
                <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                  🌏 SOCIALS
                </h3>
                <SocialsList className="mt-2" />
              </div>
            </div>
             {/* Modulo di contatto */}
            <div>
              <form className="grid grid-cols-1 gap-6">
                <label className="block">
                  <Label>Nome Completo</Label>
                  <Input
                    name="fullName"
                    placeholder="Inserisci il tuo nome completo"
                    type="text"
                    className="mt-1"
                    required
                    maxLength={50}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="block">
                  <Label>Indirizzo Email</Label>
                  <Input
                    name="email"
                    type="email"
                    placeholder="Inserisci il tuo indirizzo email"
                    className="mt-1"
                    required
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    onChange={handleInputChange}
                  />
                </label>

                <label className="block">
                  <Label>Numero Di Telefono</Label>
                  <Input
                    name="phoneNumber"
                    type="tel"
                    placeholder="Es: 3468798750"
                    className="mt-1"
                    required
                    pattern="[0-9]{10,15}"
                    maxLength={15}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="block">
                  <Label>Messaggio</Label>
                  <Textarea
                    name="message"
                    className="mt-1"
                    rows={6}
                    required
                    maxLength={500}
                    placeholder="Scrivi il tuo messaggio qui"
                    onChange={handleInputChange}
                  />
                </label>

                <div className="flex space-x-4">
                  <ButtonPrimary type="button" onClick={handleWhatsAppSubmit} disabled={!isFormValid}>
                    Invia su WhatsApp
                  </ButtonPrimary>
                  <ButtonPrimary type="button" onClick={handleEmailSubmit} disabled={!isFormValid}>
                    Invia Email
                  </ButtonPrimary>
                  <ButtonPrimary type="button" onClick={handleReset} disabled={!isFormValid}>
                    Reset
                  </ButtonPrimary>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* OTHER SECTIONS */}
      <div className="container">
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSubscribe2 className="py-24 lg:py-32" />
        </div>
        <div className="mt-5 mb-5">
          <SectionVideos />
          {/* <SectionClientSay uniqueClassName="Pagecontact_" /> */}
        </div>
      </div>
    </div>
  );
};

export default PageContact;